import { render, staticRenderFns } from "./activityRegistration.vue?vue&type=template&id=d5366a48&scoped=true&"
import script from "./activityRegistration.vue?vue&type=script&lang=js&"
export * from "./activityRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5366a48",
  null
  
)

export default component.exports